<smrts-page [tabTitle]="title">

  <div header class="header inline-element">
    <h1 #overflow="smrtsOverflowDetector" smrtsOverflowDetector class="primary-color page-title"
      [matTooltip]="title" [matTooltipDisabled]="!overflow.truncado">{{ title }}</h1>

    <p-floatLabel variant="on" class="busca-conta-field">
      <p-iconField iconPosition="left">
        <p-inputIcon styleClass="pi pi-search"></p-inputIcon>
        <input pInputText id="buscarConta" class="busca-conta-input" [value]="termoBusca"
          (input)="termoBusca = $any($event.target).value; tableComponent.filtrar(termoBusca)" />
      </p-iconField>
      <label for="buscarConta">Buscar conta</label>
    </p-floatLabel>

    <mat-divider [vertical]="true" class="vertical-mat-divider"></mat-divider>

    <ng-content></ng-content>
  </div>

  <div class="busca-conta-linha">
    <p-floatLabel variant="on">
      <p-iconField iconPosition="left">
        <p-inputIcon styleClass="pi pi-search"></p-inputIcon>
        <input pInputText id="buscarContaLinha" class="busca-conta-linha-input" [value]="termoBusca"
          (input)="termoBusca = $any($event.target).value; tableComponent.filtrar(termoBusca)" />
      </p-iconField>
      <label for="buscarContaLinha">Buscar conta</label>
    </p-floatLabel>
  </div>

  <app-conta-caixa-table #tableComponent
    [contas]="contas"
    [acoesConta]="acoesConta"
    [mostrarAdicionarTipo]="mostrarAdicionarTipo"
    [mostrarSelecaoEmMassa]="mostrarSelecaoEmMassa"
    (reloadPage)="reloadPage.emit()">

  </app-conta-caixa-table>

</smrts-page>
